import { createFileRoute } from '@tanstack/react-router';
import { SurchargesPage } from '../../features/rates';

export const Route = createFileRoute('/portal/rates/surcharges')({ component: SurchargesPage });
